import { render } from "./IntervalProgram.vue?vue&type=template&id=161ebcba"
import script from "./IntervalProgram.vue?vue&type=script&lang=js"
export * from "./IntervalProgram.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__